"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DealFeatureCategoryCodes_1 = require("../enum/DealFeatureCategoryCodes");
exports.useCarDetails = function () {
    var servicePlanToLastIndex = function (mappedOptions) {
        var _a;
        var reOrderedServicePlan = [];
        if (!((_a = mappedOptions) === null || _a === void 0 ? void 0 : _a.length)) {
            return mappedOptions;
        }
        reOrderedServicePlan.push.apply(reOrderedServicePlan, mappedOptions);
        var servicePlanContainer = mappedOptions.find(function (mappedOption, key) {
            var _a;
            if (((_a = mappedOption) === null || _a === void 0 ? void 0 : _a.categoryCode) === DealFeatureCategoryCodes_1.DealFeatureCategoryCodes.SERVICE_PLANS) {
                reOrderedServicePlan.splice(key, 1);
                return mappedOption;
            }
            return false;
        });
        if (servicePlanContainer) {
            reOrderedServicePlan.push(servicePlanContainer);
            return reOrderedServicePlan;
        }
        return mappedOptions;
    };
    return { servicePlanToLastIndex: servicePlanToLastIndex };
};
